import { UserModel } from './user.model';

export class AuthModel {

    public token: string;
    public socketToken: string;
    public user: UserModel;
    public gmtList: Array<{id: number, title: string}>;
    public permissions: {};
    public companies: Array<{id: number, name: string}>;

    constructor(obj?: any) {
        this.token       = obj && obj.token                                          || '';
        this.socketToken  = obj && obj.socketToken                                    || '';
        this.user        = obj && new UserModel(obj.user)                            || new UserModel();
        this.gmtList     = obj && obj.gmtList as Array<{id: number, title: string}>  || new Array<{id: number, title: string}>();
        this.permissions = obj && this.preparePermissions(obj.permissions)           || null;
        this.companies   = obj && obj.companies as Array<{id: number, name: string}> || null;
    }

    preparePermissions(permissions) {
        const allowedPermissions = new Array<string>();
        Object.keys(permissions).forEach(k => {
            if (permissions[k] === 1 ) {
                allowedPermissions.push(k);
            }
        });
        return allowedPermissions;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/auth.model.ts